import { styled } from '@mui/system';
import { Box, Paper, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { colors, fontFamilies } from '../../../../../constants/theme';

export const StyledDashboardCard = styled(Paper)(({ theme }) => ({
  borderRadius: '40px',
  backgroundColor: '#FFFFFF',
  minHeight: '230px',
  width: '1100px',
  margin: '0 auto',
  alignItems: 'center',
  boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.08)',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    maxWidth: '1100px',
  },
  [theme.breakpoints.down('md')]: {
    borderRadius: '25px',
    minHeight: 'auto',
  },
}));

export const CardStack = styled(Stack)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.up('md')]: {
    padding: '10px',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    padding: '0',
  },
}));

export const ImageContainer = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  width: '100%',
  height: '100%',

  [theme.breakpoints.up('md')]: {
    width: '410px',
    flex: 'none',
  },
}));

export const ImageWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'reverse',
})(({ theme, reverse = false }) => ({
  borderRadius: '30px',
  backgroundColor: colors.iconBackground,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '210px',
  [theme.breakpoints.down('md')]: {
    width: '97%',
    height: '210px',
    margin: '1.5% auto',
    justifySelf: reverse ? 'flex-end' : 'flex-start',
  },
  [theme.breakpoints.down('sm')]: {
    borderRadius: '20px',
    height: '150px',
  },
}));

export const ServiceImage = styled(Box)(({ theme }) => ({
  width: 'auto',
  maxWidth: '100%',
  height: 'auto',
  maxHeight: '100%',
  objectFit: 'contain',
}));

export const ContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'reverse',
})(({ theme, reverse = false }) => ({
  padding: reverse ? '0 51px 0 41px' : '0 41px 0 51px',
  display: 'flex',
  alignItems: 'left',
  justifyContent: 'center',
  flexDirection: 'column',
  whiteSpace: 'pre-line',
  gap: '19px',
  flex: 1,
  minWidth: 0,
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    padding: '24px 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
    gap: '12px',
  },
}));

export const ServiceTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: 18,
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  [theme.breakpoints.up('md')]: {
    fontSize: 32,
    fontFamily: fontFamilies.gotham,
    fontWeight: 400,
    lineHeight: '38px',
    letterSpacing: '0',
  },
}));

export const ServiceSubTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  marginBottom: theme.spacing(2),
  textAlign: 'center',
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: '20px',
  lineHeight: '0',
  letterSpacing: '0',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',

  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
  },
}));

export const ServiceDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  lineHeight: '23px',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    fontSize: 12,
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: 18,
    maxWidth: '578px',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: 15,
  },
}));
